import { Controller } from "@hotwired/stimulus";
import paymentMiddlewareUrlService from "../../service/payment/payment_middleware_url_service";
import PaymentMainController from "./main_controller";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = {
    currency: String,
    coupon: String,
    quantityOrder: String,
    subscriptionType: String,
  };

  paymentTypeModal = Modal.getOrCreateInstance(
    document.getElementById("choosePaymentMethod")
  );

  async connect() {
    const modal = this.paymentTypeModal._element;
    if (modal) {
      modal.addEventListener("hidden.bs.modal", () => {
        this.clearActions(modal);
      });
    }
  }

  closeModal() {
    this.paymentTypeModal.hide();
  }

  clearActions(modal) {
    const creditCardBtn = modal.querySelector(".btn-credit-card");
    const paypalBtn = modal.querySelector(".btn-paypal");

    if (creditCardBtn) creditCardBtn.setAttribute("data-action", "");
    if (paypalBtn) paypalBtn.setAttribute("data-action", "");
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-currency-value",
      ""
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-coupon-value",
      ""
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-quantity-order-value",
      ""
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-subscription-type-value",
      ""
    );
  }

  checkoutLiteYearPaypal() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "year",
    });
  }

  checkoutLiteYearCard() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "year",
    });
  }

  checkoutLiteMonthPaypal() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "month",
    });
  }

  checkoutLiteMonthCard() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "month",
    });
  }

  checkoutPremiumYearPaypal() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "year",
    });
  }

  checkoutPremiumYearCard() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "year",
    });
  }

  checkoutPremiumMonthPaypal() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "month",
    });
  }

  checkoutPremiumMonthCard() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "month",
    });
  }

  checkoutLiteService({ serviceName, period }) {
    PaymentMainController.trackLinkedInConversion();
    PaymentMainController.sendMessageToMobileApp("app_subscription_lite");
    if (period === "month") {
      window.location.href =
        paymentMiddlewareUrlService.getLiteMonthMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    } else if (period === "year") {
      window.location.href =
        paymentMiddlewareUrlService.getLiteYearMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    }
    this.paymentTypeModal.hide();
  }

  checkoutPremiumService({ serviceName, period }) {
    PaymentMainController.trackLinkedInConversion();
    PaymentMainController.sendMessageToMobileApp("app_subscription_premium");
    if (period === "month") {
      window.location.href =
        paymentMiddlewareUrlService.getPremiumMonthMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    } else if (period === "year") {
      window.location.href =
        paymentMiddlewareUrlService.getPremiumYearMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    }
    this.paymentTypeModal.hide();
  }

  checkoutLiteMultisubCard() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      type: "lite",
    });
  }

  checkoutLiteMultisubPaypal() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      type: "lite",
    });
  }

  checkoutPremiumMultisubCard() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      type: "premium",
    });
  }

  checkoutPremiumMultisubPaypal() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      type: "premium",
    });
  }

  checkoutMultisub({ serviceName, type }) {
    if (type === "premium") {
      window.location.href =
        paymentMiddlewareUrlService.getPremiumMiddlewareUrl({
          subscriptionType: this.subscriptionTypeValue,
          currency: this.currencyValue,
          quantityOrder: this.quantityOrderValue,
          coupon: this.couponValue,
          serviceName,
        });
    } else if (type === "lite") {
      window.location.href = paymentMiddlewareUrlService.getLiteMiddlewareUrl({
        subscriptionType: this.subscriptionTypeValue,
        currency: this.currencyValue,
        quantityOrder: this.quantityOrderValue,
        coupon: this.couponValue,
        serviceName,
      });
    }
  }
}
